import React from 'react';
import { withApollo } from 'react-apollo';


import {
  XYPlot,
  XAxis,
  YAxis,
  ChartLabel,
  HorizontalGridLines,
  VerticalGridLines,
  LineSeries,
  LineSeriesCanvas,
  LabelSeries,
  DiscreteColorLegend,
  LineMarkSeries,
  Hint
} from 'react-vis';


  class OutboundSummary extends React.Component {
  
    constructor(props) {
      super(props);
      this.state = { 
        drawMode: 0,
        data: this.props.callDetailsData,
        value: {},
        hoveredItem: false};
      this.mouseOverCall = this.mouseOverCall.bind(this);
      this.onNearestXYCall = this.onNearestXYCall.bind(this);
      this.mouseLeaveCall = this.mouseLeaveCall.bind(this);
      // console.log("inside NtmTrace");
    }
  
  
    mouseOverCall = () => {
      // console.log('mouseOverCallBefore', this.state.value);
      this.setState({ value: false });
      // console.log('mouseOverCallAfter', this.state.value);
    }
  
    mouseLeaveCall = () => {
      // console.log('mouseLeaveCallBefore', this.state.value);
      this.setState({ value: false });
      // console.log('mouseLeaveCallAfter', this.state.value);
    }
  
    onNearestXYCall = (domain, type, inpValue) =>{
      // console.log('onNearestXYCallActual', domain, type, inpValue)
      const simpleDate= new Date(inpValue.x).toLocaleDateString()
      const finalValue = {Date: simpleDate, Type: type, Count : inpValue.y, x:inpValue.x, y:inpValue.y};
      this.setState(({ value }) => ({ value: { ...value, [type]: finalValue } }))
      // console.log('onNearestXYCall', this.state.value);
    }
  
    render() {
      const { callDetailsData } = this.props;
      const { classes } = this.props;
      const colorArray = ['#92A8D1','#6B5B95','#88B04B','#FF6F61','#F7CAC9','#955251','#B565A7'];
      const hintStyle = {
        background: 'black', 
        borderRadius: '10px', 
        padding: '5px'
      };
      // console.log("render", callDetailsData);
      // let data = [];
      // if(callDetailsData.length>0){
      //   data = callDetailsData[0].attemptsData;
      // }

      return (
        <div>
        <label><h3>Outbound Calls</h3></label>
        <XYPlot xType="time" width={800} height={400} margin={{left: 100, bottom: 100, right:100}}
        onMouseLeave={() => {this.setState({ value: false})}}>
        <HorizontalGridLines />
        <VerticalGridLines />
        <XAxis style={{
            text: {stroke: 'none', fill: '#6b6b76', fontSize: '14px', fontWeight: '600'}
          }} 
          tickFormat={function tickFormat(d){
            const date = new Date(d);
            const dispDate = date.toISOString().substr(5,2) + '/' + date.toISOString().substr(8,2);
            return dispDate
           }} 
           tickTotal={7}/>
        <YAxis style={{
            text: {stroke: 'none', fill: '#6b6b76', fontSize: '14px', fontWeight: '600'}
          }}/>
        <ChartLabel 
          text="Time"
          includeMargin={true}
          xPercent={0.55}
          yPercent={0.63}
          style={{
            textAnchor: 'middle'
          }}
          />
  
        <ChartLabel 
          text="Count"
          includeMargin={true}
          xPercent={0.03}
          yPercent={0.1}
          style={{
            transform: 'rotate(-90)',
            textAnchor: 'middle'
          }}
          />
          {
            callDetailsData.map((callData, index) => {
              const { domain, attemptsData, ansData, unAnsData, errorData } = callData;
              const hintAns = this.state.value["Answered"];
              const hintUnAns = this.state.value["Unanswered"];
              const hintAttempts = this.state.value["Attempts"];
              const hintErrors = this.state.value["Error"];
              // console.log({ domain, attemptsData, ansData, unAnsData, errorData, hintAns, hintUnAns, hintAttempts, hintErrors});
  
              return [
                      <LineMarkSeries key={"OutLineMarkSeriesAttempts"+index}
                        className="linemark-series-example"
                        style={{
                          strokeWidth: '3px'
                        }}
                        lineStyle={{stroke: colorArray[index]}}
                        markStyle={{stroke: colorArray[index]}}
                        // data={[{x: 1, y: 10}, {x: 2, y: 5}, {x: 3, y: 15}]}
                        data = {attemptsData}
                        onMouseLeave={this.mouseLeaveCall}
                        onSeriesMouseOver={this.mouseOverCall}
                        onNearestXY={(value) => this.onNearestXYCall(domain, "Attempts", value)} 
                        // {...markSeriesProps}
                      />,
                      <LineMarkSeries key={"OutLineMarkSeriesAns"+index}
                      className="linemark-series-example"
                      style={{
                        strokeWidth: '3px'
                      }}
                      lineStyle={{stroke: colorArray[index+1]}}
                      markStyle={{stroke: colorArray[index+1]}}
                      // data={[{x: 1, y: 10}, {x: 2, y: 5}, {x: 3, y: 15}]}
                      data = {ansData}
                      onMouseLeave={this.mouseLeaveCall}
                      onSeriesMouseOver={this.mouseOverCall}
                      onNearestXY={(value) => this.onNearestXYCall(domain, "Answered", value)} 
                      // {...markSeriesProps}
                    />,
                    <LineMarkSeries key={"OutLineMarkSeriesUnAns"+index}
                    className="linemark-series-example"
                    style={{
                      strokeWidth: '3px'
                    }}
                    lineStyle={{stroke: colorArray[index+2]}}
                    markStyle={{stroke: colorArray[index+2]}}
                    // data={[{x: 1, y: 10}, {x: 2, y: 5}, {x: 3, y: 15}]}
                    data = {unAnsData}
                    onMouseLeave={this.mouseLeaveCall}
                    onSeriesMouseOver={this.mouseOverCall}
                    onNearestXY={(value) => this.onNearestXYCall(domain, "Unanswered", value)} 
                    // {...markSeriesProps}
                  />,
                  <LineMarkSeries key={"OutLineMarkSeriesError"+index}
                  className="linemark-series-example"
                  style={{
                    strokeWidth: '3px'
                  }}
                  lineStyle={{stroke: colorArray[index+3]}}
                  markStyle={{stroke: colorArray[index+3]}}
                  // data={[{x: 1, y: 10}, {x: 2, y: 5}, {x: 3, y: 15}]}
                  data = {errorData}
                  onMouseLeave={this.mouseLeaveCall}
                  onSeriesMouseOver={this.mouseOverCall}
                  onNearestXY={(value) => this.onNearestXYCall(domain, "Error", value)} 
                  // {...markSeriesProps}
                />,
                hintAttempts ?
                <Hint key={"OutHintAttempts"+index} value={hintAttempts || {}} >
                      <div style={hintStyle}>
                        <span>Date : {hintAttempts.Date} | {hintAttempts.Type} : {hintAttempts.Count}</span>
                      </div>
                </Hint> : null,
                hintUnAns ?
                <Hint key={"OutHintUnanswered"+index} value={hintUnAns || {}} >
                      <div style={hintStyle}>
                        <span>Date : {hintUnAns.Date} | {hintUnAns.Type} : {hintUnAns.Count}</span>
                      </div> 
                </Hint> : null,
                hintErrors ?
                <Hint key={"OutHintError"+index} value={hintErrors || {}} >
                      <div style={hintStyle}>
                        <span>Date : {hintErrors.Date} | {hintErrors.Type} : {hintErrors.Count}</span>
                      </div> 
                </Hint> : null,
                hintAns ?
                <Hint key={"OutHintAnswered"+index} value={hintAns || {}} >
                      <div style={hintStyle}>
                        <span>Date : {hintAns.Date} | {hintAns.Type} : {hintAns.Count}</span>
                      </div> 
                </Hint> : null            
              ];
             }
            )          
          }
        </XYPlot>
        <> 
        {
          callDetailsData.map((callData, index) => {
            const { domain, attemptsData, ansData, unAnsData, errorData } = callData;
            // console.log(attemptsData[index].legend,ansData[index].legend,unAnsData[index].legend,errorData[index].legend)
            return[
              <DiscreteColorLegend key= {"LegendOutbound"+index}
              width={180}
              items={[{title: attemptsData[index].legend, color: colorArray[index]},
                      {title: ansData[index].legend, color: colorArray[index+1]},
                      {title: unAnsData[index].legend, color: colorArray[index+2]},
                      {title: errorData[index].legend, color: colorArray[index+3]}]}
            />
            ];
          })
        }
        </>
        </div>
      )
      }
  }

export default (withApollo(OutboundSummary));
